import { useEffect, useRef } from 'react'
import { DEFAULT_DOCUMENT_TITLE } from 'config'

function getTitleName(titleFuncOrString, props) {
  return typeof titleFuncOrString === 'function'
    ? titleFuncOrString(props)
    : titleFuncOrString
}

/**
 * @param {string|function(any): string} titleFuncOrString
 * @param {unknown[]} [deps] - When set, the effect depends on these values (titleFuncOrString is read on each run). When omitted, the effect re-runs when the computed title string changes — fixing stale titles when `t()` or data updates after first paint.
 */
function useDocumentTitle(titleFuncOrString, deps) {
  const priorTitleRef = useRef(null)
  if (priorTitleRef.current === null) {
    priorTitleRef.current = document.title
  }

  const computedTitle = getTitleName(titleFuncOrString)
  const effectDeps = deps !== undefined ? deps : [computedTitle]

  useEffect(() => {
    const newTitle = getTitleName(titleFuncOrString) || DEFAULT_DOCUMENT_TITLE
    document.title = newTitle
  }, effectDeps)

  useEffect(() => {
    return () => {
      document.title = priorTitleRef.current
    }
  }, [])
}

export default useDocumentTitle
